export default __webpack_public_path__ + "static/media/mariaFilo_desk_banner_1.22acfbd5.jpg";